let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k4zbq")).then(() => parcelRequire('cMIbn'));